
export default {
  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
};
